import { CrownFilled, UserOutlined } from "@ant-design/icons";
import { Avatar, Carousel, Col, Image, Row, Space, Typography } from "antd";
import { Fragment } from "react/jsx-runtime"
import { formatDay, formatTicketNumber, selectFirstPlace } from "../../../util/utils";

import "./WinnerCard.css";

const { Title, Text } = Typography;

const InfoRow = ({ label, value, isPrize = false }) => (
    <div className="info-row">
        <Text className="info-label">{label}</Text>
        <Text className={isPrize ? "info-value-prize" : "info-value"}>{value}</Text>
    </div>
);

export default function WinnerCard(props) {
    const { item, index } = props;
    return (
        <Fragment key={index}>
            <div className="winner-card-premium">

                <Carousel autoplay dots={{ className: 'carousel-dots-white' }}>
                    {item?.photosWinners?.map((photo, index) => (
                        <div key={index} style={{ width: '100%' }}>
                            <Image
                                src={photo.photoLink}
                                alt={`Premio ${index + 1}`}
                                style={{ width: '100%', height: '250px', objectFit: 'cover' }}
                            />
                        </div>
                    ))}
                </Carousel>

                <div style={{ padding: '20px 24px' }}>
                    <Title level={4} className="title-winner">
                        ¡FELICIDADES AL GANADOR!
                    </Title>
                    <Text className="raffle-name">{item?.lotto?.title}</Text>

                    <Row gutter={16} align="middle" style={{ marginBottom: 20 }}>
                        <Col span={7} style={{ textAlign: 'center' }}>
                            <Avatar
                                //src="https://i.pravatar.cc/150?img=17"
                                size={90}
                                icon={<UserOutlined />}
                                className="winner-avatar"
                            />
                            <CrownFilled style={{ color: "#D4AF37", fontSize: '1.5em', marginTop: 5 }} />
                        </Col>
                        <Col span={17}>
                            <Title level={3} style={{ margin: 0, color: '#333' }}>
                                {item?.name} {item?.lastName}
                            </Title>
                            <Text strong style={{ color: '#888' }}>
                                {item?.state}
                            </Text>
                        </Col>
                    </Row>

                    <Space direction="vertical" style={{ width: '100%' }}>
                        <InfoRow label="PREMIO:" value={selectFirstPlace(item?.lotto?.awards)} isPrize={true} />
                        <InfoRow label="FECHA DEL SORTEO:" value={formatDay(item?.lotto?.lottoDate)} />
                        <InfoRow label="BOLETO:" value={formatTicketNumber(item?.winnerTicket?.ticketNumber, item?.lotto?.ticketAmount)} />
                        <InfoRow label={item?.winnerTicket?.subTickets?.length > 5 ? "OPPS:" : "OPORTUNIDADES:"} value={item?.winnerTicket?.subTickets?.length > 0 && item?.winnerTicket?.subTickets?.map((subTicket, ind) => (
                            <Text className='info-value' key={ind}>{ind === 0 ? "" : ", "}{formatTicketNumber(subTicket?.subTicketNumber, item?.lotto?.ticketAmount)}</Text>
                        ))} />
                    </Space>
                </div>

                <div className="gold-banner">
                    <Text>¡Tu siguiente gran premio está en</Text>
                    <br />
                    <Text>Rifas Gran Familia Guadalajara!</Text>
                </div>
            </div>
        </Fragment>
    );
}